import React from 'react';

import Chip from '@mui/material/Chip';

import { RequestType } from 'stores/ContractRequestStoreAdapter';

const RequestTypeColor: Record<RequestType, string> = {
  CREATE: '#1976d2',
  CHANGE: '#ed6c02',
  TERMINATE: '#d32f2f',
};

type Props = {
  requestType: RequestType;
  size?: 'small' | 'medium';
};

const RequestTypeChip: React.FC<Props> = ({ requestType, size = 'small' }) => {
  const color = RequestTypeColor[requestType];
  return (
    <Chip
      label={RequestType[requestType]}
      size={size}
      sx={{
        color: '#fff',
        backgroundColor: color,
        fontWeight: 400,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default RequestTypeChip;
